import './opt-out-confirm-form.scss';
import { ConfirmedForm } from './confirmed-form';
import { connect } from 'react-redux';
import { LoadingPane } from '@social-solutions/ssg-forms';
import { LegalSection, ssgFormsAdapters } from '../../common';
import { PropTypes } from 'prop-types';
import { renderLogo } from '../acct.util';
import { withRouter } from 'react-router-dom';
import React, { Component } from 'react';

/**
 * Displays a read only page informing the user that
 * his opt out choice has been confirmed.
 */
export class ConfirmedComponent extends Component {

  render() {
    const { title, optOut, tenant } = this.props;

    var redemptionState = ssgFormsAdapters.convertLoadingState(optOut.redemption);

    if(!redemptionState.isLoading && !redemptionState.error) {
      redemptionState.data = {};
    }

    if(!!redemptionState.error) {
      redemptionState.error.errorCode = 'processing-failure';
      redemptionState.error.errorMessage = 'Unable to process request.';
    }

    return (
      <div>
        <div id="opt-out-confirm">
          <LoadingPane id="opt-out-confirm-pane" loadingState={redemptionState} loadingMessage={"Confirming..."}>
            {renderLogo(tenant)}
            <div className="opt-out-confirm-form-container">
              <ConfirmedForm title={title}/>
            </div>
            <div id="legal-wrapper">
              <LegalSection />
            </div>
          </LoadingPane>
        </div>
      </div>

    );
  }
}

ConfirmedComponent.defaultProps = {
  title: "Confirmation",
};

ConfirmedComponent.propTypes = {
  title: PropTypes.string.isRequired,
};

const mapStateToProps = ({ optOut, tenant }) => {
  return {
    optOut,
    tenant,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfirmedComponent));



// WEBPACK FOOTER //
// src/acct/opt-out/confirmed-component.js